export const RedirectType = {
  GOOGLE: 'google',
  LOGOUT: 'logout',
  NONE: 'none',
};

export const fromQueryParam = (param) => {
  switch (param) {
    case 'google':
      return RedirectType.GOOGLE;
    case 'logout':
      return RedirectType.LOGOUT;
    default:
      return RedirectType.NONE;
  }
};
